import React, { useEffect, useState } from 'react';
import NavMenu from './NavMenu';
import { toggleModal } from '../../utils/displaySlice';
import { useAppDispatch, useAppSelector } from '../../utils/storeHooks';

const FadeScreen = () => {

    const [isVisible, setIsVisible] = useState(false);
    const dispatch = useAppDispatch();
    const { modal } = useAppSelector((store) => store.display);
    let modalWindow: React.JSX.Element | string = <></>;
    let show: boolean = false;

    const handleCloseModal = () => {
        setIsVisible(false); // Start fade
        setTimeout(() => { // Wait for animation to complete before removing modal
            dispatch(toggleModal(''));
        }, 300);
    };

    useEffect(() => {

        //@ts-expect-error: Don't worry
        const handleEsc = (e) => {
            if (e.key === "Escape") {
                handleCloseModal();
            }
        };
        
        // Trigger slide-in after mount
        requestAnimationFrame(() => {
            setIsVisible(true);
        });

        document.addEventListener("keydown", handleEsc);

        return () => document.removeEventListener("keydown", handleEsc);

    }, [handleCloseModal]);


    switch (modal) {
        case 'NavMenu':{
            modalWindow = <NavMenu closeModal={handleCloseModal} showModal={isVisible} />;
            show = true;
            break;
        }
    };

    const opacity = !show ? '0' // Don't show fadescreen if modal does not require it.
    : isVisible ? '0.4' : '0'; // If modal takes fadescreen this allows it to animate in/out.

    return (
        <>
            <div className="exitModal" style={{opacity: opacity}} onClick={handleCloseModal}></div>
            { modalWindow }
        </>
    )
};

export default FadeScreen;